export const VALOR_FENOFASE_OBSERVADA = 1;
export const VALOR_FENOFASE_NO_OBSERVADA = 2;
export const VALOR_FENOFASE_DUBTE = 3;
//Rang màxim de dies per fer cerca a opció menú "Visualitzar observacions"
export const MAXIM_DIES_PERIODE = 90;
// Nombre mesos abans data actual en que es poden informar observacions
export const MAX_MONTH_LAST_OBSERVATION = 2;
// Nombre dies abans data actual per mostrar missatge darrera observació
export const DIES_MISSATGE_DARRERA_OBSERVACIO = 6;
// Temps de retard de l'sppiner al fer actualitzacions
export const RETARD_MILISEGONS_APARICIO_SPINNER = 100;

export const FORMAT_YYYYMMDD = "YYYY-MM-DD";
export const FORMAT_DDMMYYYY = "DD-MM-YYYY";
export const FORMAT_DDMMYY = "DD-MM-YY";

export const COLOR_OBSERVACIO_SI = "#7bc02a";
export const COLOR_OBSERVACIO_NO = "#ee2d1e";
export const COLOR_OBSERVACIO_DUBTE = "#ffa500";
export const COLOR_PUNT_OBSERVADOR = "#0058D2";

export const colorsIcones = {
  1: COLOR_OBSERVACIO_SI,
  2: COLOR_OBSERVACIO_NO,
  3: COLOR_OBSERVACIO_DUBTE,
  4: COLOR_PUNT_OBSERVADOR
};

export const valorsTaula = {
  1: "S",
  2: "N",
  3: "d"
};

export const VALOR_MAX_COMENTARI = 255;
export const DATA_PASSAT_NO_MOSTRAR_SELECTOR_OBSERVACIONS =
  "2019-01-01T00:00+00:00";
export const DATA_PASSAT_NO_MOSTRAR_SELECTOR_OBSERVACIONS_ADMIN =
  "2013-01-01T00:00+00:00";
export const LOCAL_STORAGE_USER = "web-fenocat-user";
export const LOCAL_STORAGE_ACTIVE_SESSION_TAB =
  "web-fenocat-active-session-tab";
export const LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT =
  "web-fenocat-active-session-tab-heartbeat";
export const SESSION_STORAGE_TAB_ID = "web-fenocat-tab-id";
export const SESSION_STORAGE_RELOAD_FLAG = "fenocat-reload-in-progress";
export const SESSION_STORAGE_TOKEN_BACKUP = "fenocat-token-backup";

// Nombre dies abans data actual per mostrar missatge darrera observació
export const ANY_INICI_OBSERVACIONS = 2013;
